import { request } from "./http";

export interface Campaign {
  id: string;
  name: string;
  subject: string;
  body_template: string;
  kind: string;
  enabled: boolean;
  created_at: string | null;
}

export interface CampaignCreate {
  name: string;
  subject: string;
  body_template: string;
  kind?: string;
  enabled?: boolean;
}

export const marketing = {
  list: () => request<Campaign[]>("/api/v1/admin/marketing/campaigns"),
  create: (body: CampaignCreate) =>
    request<Campaign>("/api/v1/admin/marketing/campaigns", { body }),
  patch: (id: string, body: Partial<CampaignCreate>) =>
    request<Campaign>(`/api/v1/admin/marketing/campaigns/${id}`, { method: "PATCH", body }),
};
